import { Type } from "class-transformer";
import { observable } from "mobx";
import { EntityValidationRules } from "../services/validationService";
import { maxValidSince, minValidSince } from "../utils/dateUtils";

export default class Validity {
  @Type(() => Date)
  @observable
  validSince: Date;

  @Type(() => Date)
  @observable
  validUntil: Date;

  @observable
  authCode?: string;

  @observable
  emailAddress?: string;

  @observable
  canBeChanged: boolean;
}

export function validityValidationRulesFactory(paidAt?: Date): EntityValidationRules<Validity> {
  return {
    validSince: {
      required: true,
      dateRange: {
        min: minValidSince(),
        max: maxValidSince(paidAt),
      },
    },
  };
}
